import { defineComponent as V, ref as m, computed as i, toRef as b, resolveComponent as n, openBlock as s, createElementBlock as v, normalizeClass as M, createVNode as k, withCtx as p, createElementVNode as B, toDisplayString as y, createBlock as S, createCommentVNode as _, Fragment as C, renderList as I, createTextVNode as L } from "vue";
import { useProxyModelValue as $ } from "@onereach/ui-components-common/hooks";
import { O as w } from "./OrButton-C_hXddAf.mjs";
import { O as N } from "./OrIcon-k8cyvh-D.mjs";
import { O as A } from "./OrMenuItem-BHRMA0L1.mjs";
import { O as h } from "./OrMenu-CJT4Snay.mjs";
import { _ as E } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const R = [], z = [
  // Theme
  "text-on-background dark:text-on-background-dark"
], D = V({
  name: "OrSorting",
  components: {
    OrButton: w,
    OrIcon: N,
    OrMenu: h,
    OrMenuItem: A
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: String,
      default: void 0
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  emits: [
    "update:modelValue"
  ],
  setup(o, t) {
    const d = m(), c = m(), f = m(), O = i(() => [
      "or-sorting-v3",
      ...R
    ]), l = i(() => [
      ...z
    ]), r = $(b(o, "modelValue"), t.emit), a = i(() => {
      var e;
      return (e = o.options.find((g) => g.value === r.value)) == null ? void 0 : e.label;
    });
    function u(e) {
      r.value = e;
    }
    return {
      root: d,
      rootStyles: O,
      sortLabelStyles: l,
      sortMenu: c,
      sortButton: f,
      sortLabel: a,
      handleSort: u
    };
  }
});
function F(o, t, d, c, f, O) {
  const l = n("OrIcon"), r = n("OrButton"), a = n("OrMenuItem"), u = n("OrMenu");
  return s(), v("div", {
    ref: "root",
    class: M(o.rootStyles)
  }, [
    k(r, {
      ref: "sortButton",
      variant: "link",
      color: "primary",
      onClick: t[0] || (t[0] = (e) => o.sortMenu && o.sortMenu.toggle())
    }, {
      default: p(() => [
        B("span", {
          class: M(o.sortLabelStyles)
        }, y(o.sortLabel), 3),
        o.sortMenu ? (s(), S(l, {
          key: 0,
          icon: o.sortMenu.state === "open" ? "arrow_drop_up" : "arrow_drop_down"
        }, null, 8, ["icon"])) : _("", !0)
      ]),
      _: 1
    }),
    k(u, {
      ref: "sortMenu",
      trigger: o.sortButton && o.sortButton.root,
      placement: "bottom-start",
      offset: { mainAxis: 8, crossAxis: -8 }
    }, {
      default: p(() => [
        (s(!0), v(C, null, I(o.options, (e) => (s(), S(a, {
          key: e.value,
          selected: e.value === o.modelValue,
          onClick: (g) => o.handleSort(e.value)
        }, {
          default: p(() => [
            L(y(e.label), 1)
          ]),
          _: 2
        }, 1032, ["selected", "onClick"]))), 128))
      ]),
      _: 1
    }, 8, ["trigger"])
  ], 2);
}
const K = /* @__PURE__ */ E(D, [["render", F]]);
export {
  K as O
};
//# sourceMappingURL=OrSorting-DCAarSF1.mjs.map
